import stylex from '@stylexjs/stylex';

import { fonts } from '@shared/tokens/fonts.stylex';
import { colors } from '@shared/tokens/colors.stylex';
import { typography } from '@shared/tokens/typography.stylex';
import { palette } from '@shared/tokens/palette.stylex';
import { anatomy } from '@shared/tokens/anatomy.stylex';

export const styles = stylex.create({
  container: {
    display: 'flex',
    flexDirection: 'column',
    fontFamily: fonts.din2014Regular,
    padding: '0px',
  },

  xMarkIcon: {
    fill: colors.tertiaryIcon,
  },
  headerContainer: {
    maxHeight: '64px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingRight: '24px',
  },
  header: {
    padding: '16px 24px',
    color: colors.primaryText,
    fontSize: typography['fontSizeHeading-4'],
    fontFamily: fonts.din2014Regular,
    fontWeight: typography.fontWeighDemi,
    lineHeight: typography['lineHeightBody-1'],
  },
  organizerHeaderContainer: {
    maxHeight: 'none',
    paddingRight: '16px',
    alignItems: 'flex-start',
  },
  organizerHeader: {
    padding: `${anatomy['space-28']} 56px ${anatomy['space-28']} ${anatomy['space-28']}`,
    color: colors.primaryText,
    fontSize: typography['fontSizeHeading-3'],
    fontFamily: fonts.din2014Regular,
    fontWeight: typography.fontWeighDemi,
    lineHeight: typography['fontSizeHeading-1'],
  },
  organizerXMarkIcon: {
    fill: colors.primaryIcon,
    marginTop: anatomy['space-16'],
  },
  organizerTextHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    color: colors.secondaryText,
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-2'],
    lineHeight: '12px',
    paddingBottom: anatomy['space-4'],
  },
  organizerInputWrapper: {
    display: 'flex',
    flexDirection: 'column',
    padding: `0 ${anatomy['space-28']} ${anatomy['space-24']}`,
    gap: anatomy['space-20'],
  },
  headerSendTickets: {
    padding: '16px 32px',
    color: colors.primaryText,
    fontSize: typography['fontSizeHeading-4'],
    fontFamily: fonts.din2014Regular,
    fontWeight: typography.fontWeighDemi,
    lineHeight: typography['lineHeightBody-1'],
  },
  actions: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: anatomy['space-8'],
    padding: ' 16px 24px 16px ',
  },
  loader: {
    display: 'flex',
    alignItems: 'center',
    padding: '0 24px',
    gap: anatomy['space-16'],
  },
  inputWrapper: {
    display: 'flex',
    padding: '0px 24px',
    flexDirection: 'column',
    gap: anatomy['space-16'],
  },
  smsBlock: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  smsBlockLabel: {
    fontSize: typography['fontSizeCaption-2'],
    lineHeight: typography['lineHeightCaption-2'],
    color: colors.secondaryText,
  },
  smsBlockValue: {
    padding: '7px 12px',
    borderRadius: anatomy.borderRadiusS,
    border: `1px solid ${colors.tertiaryBorder}`,
    fontSize: typography['fontSizeCaption-1'],
    color: colors.primaryText,
  },

  switcherLabel: {
    fontSize: '14px',
    paddingLeft: '8px',
    color: colors.primaryText,
  },
  row: { display: 'flex', flexDirection: 'row', alignItems: 'center' },

  input: {
    paddingBottom: '14px',
  },
  message: {
    padding: anatomy['size-12'],
    borderRadius: anatomy.borderRadiusS,
    border: `1px solid ${colors.tertiaryBorder}`,
    lineHeight: typography['lineHeightCaption-1'],
    ':not(#__unused__) > div': {
      overflow: 'visible',
    },
  },
  tiptap: {
    width: '100%',
    maxWidth: '406px',
    padding: '8px',
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-1'],
    lineHeight: typography['lineHeightCaption-1'],
    color: colors.primaryText,
    ':not(#__unused__) > div': {
      outline: 'none !important',
      minHeight: '60px',
    },
    ':not(#__unused__) > div > p:not(:first-child)': {
      paddingTop: anatomy['size-20'],
      minHeight: anatomy['size-20'],
      boxSizing: 'content-box',
    },
    ':not(#__unused__) a': {
      color: colors.accentText,
    },
    ':not(#__unused__) p.is-empty': {
      color: palette['grey-500'],
    },
  },
  previewText: {
    padding: 0,
    paddingLeft: anatomy['size-4'],
    ':not(#__unused__) > div': {
      minHeight: 'auto',
    },
    wordWrap: 'break-word',
  },
  textCount: {
    position: 'absolute',
    zIndex: -1,
    color: palette['grey-500'],
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-2'],
    fontWeight: typography.fontWeighRegular,
    right: '25px',
    top: '139px',
  },
  previewContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: anatomy['size-4'],
    alignSelf: 'stretch',
    width: '432px',
  },
  labelPreview: {
    color: colors.secondaryText,
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-2'],
    fontStyle: 'normal',
    fontWeight: typography.fontWeighRegular,
    lineHeight: typography['lineHeightCaption-2'],
  },
  areaPreview: {
    minHeight: '72px',
    display: 'flex',
    padding: anatomy['size-16'],
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: anatomy['size-8'],
    alignSelf: 'stretch',
    borderRadius: '8px',
    background: colors.ghostBackground,
    overflow: 'auto',
  },
  messagePreview: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    color: palette['grey-700'],
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-2'],
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '12px',
    whiteSpace: 'normal',
    wordWrap: 'break-word',
    wordBreak: 'break-all',
  },
  linkPreview: {
    color: colors.accentText,
    fontFamily: fonts.din2014Regular,
    fontSize: '10px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '12px',
    textDecorationLine: 'underline',
    textDecorationStyle: 'solid',
    textDecorationSkipInk: 'auto',
    textDecorationThickness: 'auto',
    textUnderlineOffset: 'auto',
    textUnderlinePosition: 'from-font',
    marginTop: 'auto',
  },

  infoQuantity: {
    position: 'absolute',
    left: '24px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    alignSelf: 'stretch',
  },
  infoText: {
    overflow: 'hidden',
    color: colors.secondaryText,
    textOverflow: 'ellipsis',
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-2'],
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: typography['lineHeightCaption-2'],
  },
  infoCount: {
    overflow: 'hidden',
    color: colors.primaryText,
    textOverflow: 'ellipsis',
    fontFamily: fonts.din2014Demi,
    fontSize: typography['fontSizeCaption-2'],
    fontStyle: 'normal',
    fontWeight: '600',
    lineHeight: typography['lineHeightCaption-2'],
  },
  text: {
    fontSize: typography['fontSizeCaption-1'],
    color: colors.secondaryText,
  },
  btn: {
    display: 'flex',
    padding: '16px 24px',
    alignSelf: 'flex-end',
  },
  errorText: {
    position: 'absolute',
    color: palette['red-500'],
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-3'],
    fontWeight: typography.fontWeighRegular,
    lineHeight: typography['lineHeightCaption-2'],
    marginTop: '56px',
  },
  alertContainer: {
    display: 'flex',
    padding: '16px',
    alignItems: 'center',
    gap: anatomy['size-8'],
    alignSelf: 'stretch',
    borderRadius: anatomy.borderRadiusM,
    background: 'var(--Background-Info, #EDF2FD)',
    marginTop: anatomy['size-8'],
  },
  alertText: {
    color: colors.primaryText,
    fontSize: typography['fontSizeBody-4'],
    lineHeight: '21px',
    width: '100%',
  },
});
